import { Component, HostBinding, OnInit } from '@angular/core';
import { ThemingService } from '@michelin/theme';

@Component({
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {
  @HostBinding('class') className = this.themingService.theme.className;
  isUnauthorized: boolean = false;
  constructor(private readonly themingService: ThemingService) {}

  ngOnInit(): void {
    const unauthorized = sessionStorage.getItem('unauthorized');
    if(unauthorized && unauthorized === 'unauthorized'){
      this.isUnauthorized = true;
    }
    sessionStorage.clear();
  }
}
